// services/QuestionDifficultyService.js
import api from "../utils/axios";
import { ENDPOINTS } from "../utils/endpoints";

export function getQuestionDifficulties(params = {}) {
    return api.get(ENDPOINTS.QUESTION_DIFFICULTIES.BASE, { params });
}
export function createQuestionDifficulty(payload) {
    return api.post(ENDPOINTS.QUESTION_DIFFICULTIES.BASE, payload);
}
export function updateQuestionDifficulty(id, payload) {
    return api.patch(ENDPOINTS.QUESTION_DIFFICULTIES.BY_ID(id), payload);
}
export function deleteQuestionDifficulty(id) {
    return api.delete(ENDPOINTS.QUESTION_DIFFICULTIES.BY_ID(id));
}
export function restoreQuestionDifficulty(id) {
    return api.post(`${ENDPOINTS.QUESTION_DIFFICULTIES.BY_ID(id)}/restore`);
}
